import React from 'react'
import { mark, markHover } from '../data/record'

// One footer, used by every page. It was duplicated inline in Main.jsx and
// Scroller.jsx, which is why the YouTube icon had to be added twice last time.
// Swap those blocks for <SiteFooter /> and any future change lands everywhere
// at once.

// Two explicit rows. On a phone these stack three then two, both centred; on
// a desktop the second row simply sits under the first. Letting five items
// wrap on their own scattered them.
// One flat list. Nesting the links in two containers meant the hairline rule
// between siblings never applied across the join, so the separator between the
// third and fourth was always missing. The break below splits them into two
// rows on a phone without breaking the sequence.
const links = [
  { label: 'Watch the film', href: '/#watch' },
  { label: 'Screenings', href: '/screenings' },
  { label: 'Be Aware', href: '/climate-awareness' },
  { label: 'Climate Resilience', href: '/climate-resilience' },
  { label: 'Links', href: '/links' },
  { label: 'Contact', href: '/#contact' },
]

const BREAK_AFTER = 3

const SiteFooter = () => (
  <footer className='footer'>
    <div className='content-container footer-inner'>
      <p className='footer-mark'>
        <a href='/' aria-label='The Girl and Her Piano, home'>
          <img className='is-rest' src={mark} alt='' aria-hidden='true' />
          <img className='is-hover' src={markHover} alt='' aria-hidden='true' />
        </a>
      </p>

      <nav className='footer-nav' aria-label='Footer'>
        {links.map((l, i) => (
          <React.Fragment key={l.href}>
            {i === BREAK_AFTER && <span className='footer-nav-break' aria-hidden='true' />}
            <a className={i === BREAK_AFTER ? 'is-rowstart' : ''} href={l.href}>{l.label}</a>
          </React.Fragment>
        ))}
      </nav>

      <div className='social-icons'>
        <a href='https://www.instagram.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer' aria-label='Instagram' className='social-icon'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <rect x='2' y='2' width='20' height='20' rx='5' ry='5'></rect>
            <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z'></path>
            <line x1='17.5' y1='6.5' x2='17.51' y2='6.5'></line>
          </svg>
        </a>
        <a href='https://www.facebook.com/thegirlandherpiano' target='_blank' rel='noopener noreferrer' aria-label='Facebook' className='social-icon'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='currentColor' stroke='currentColor' strokeWidth='0.5' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z'></path>
          </svg>
        </a>
        <a href='https://www.youtube.com/@hillaryosullivan' target='_blank' rel='noopener noreferrer' aria-label='YouTube' className='social-icon social-icon--youtube'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='currentColor'>
            <path d='M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.4 31.4 0 0 0 24 12a31.4 31.4 0 0 0-.5-5.8zM9.6 15.6V8.4l6.3 3.6z'></path>
          </svg>
        </a>
        <a href='https://www.imdb.com/title/tt37798371/' target='_blank' rel='noopener noreferrer' aria-label='IMDb' className='social-icon social-icon--imdb'>IMDb</a>
        <a href='mailto:info@thegirlandherpiano.com' aria-label='Email' className='social-icon'>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'></path>
            <polyline points='22,6 12,13 2,6'></polyline>
          </svg>
        </a>
      </div>

      <p className='footer-legal'>© 2026 White Room Studio Pte Ltd. All rights reserved.</p>
    </div>
  </footer>
)

export default SiteFooter
